<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="ch_menu(item.id)" >
            <span *ngIf="chat_obj.me!='-1'||item.id<2" [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <div *ngIf="now=='0'" style="margin-left:10px ;">
        <select class="form-control" style="width: 160px;display: inline-block;" [(ngModel)]="search_gender" (change)="init_list()">
            <option *ngFor="let item of gender_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
    
        <select class="form-control" style="width: 160px;display: inline-block;" [(ngModel)]="search_country" (change)="init_list()">
            <option *ngFor="let item of country_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
      
        <input (keyup.enter)="init_list()" type="text" [(ngModel)]="search_model" style="width: 160px;display:inline-block" class="form-control" placeholder="請輸入姓名或手機">
        <button class="btn btn-primary"  (click)="init_list()">確認</button> 
        <r-table [data]="posts_input"  (callback)="init_list()">
            <ng-template let-post #operation_dk>
                <span *ngIf="data[post.idx] && post.key == 'name'">
                    <a target="_blank" href="{{link}}/user/{{data[post.idx].uid}}">
                        <span class="user_identity_{{data[post.idx].identity}}">
                            {{data[post.idx].name}}
                            <div *ngIf="data[post.idx].v_name && data[post.idx].v_name.length>0">({{data[post.idx].v_name}})</div>
                        </span>
                    </a>
                </span>
                <span *ngIf="data[post.idx] && post.key=='profile_pic'">
                    <app-userinfo [cls]="'dkimg'" [data]="data[post.idx]"></app-userinfo> 
                </span>
                <span *ngIf="data[post.idx] && post.key=='send_chats_num'" (click)="get_chat(data[post.idx]);">
                    <a href="javascript:void(0)">{{data[post.idx].send_chats_num}}</a>
                </span>
                <span *ngIf="data[post.idx] &&  post.key=='receve_chats_num'" (click)="get_chat(data[post.idx]);">
                    <a href="javascript:void(0)">{{data[post.idx].receve_chats_num}}</a>
                </span>
                <span *ngIf="data[post.idx] &&  post.key=='diamond'" id="ggwp0">
                    <div (mouseover)="showLink[post.idx] = true" (mouseout)="startHideTimer(post.idx)" style=" padding: 10px;">
                        <a href="javascript:void(0)">{{data[post.idx].diamond|number}}鑽</a>
                    </div>       
                    <div *ngIf="showLink[post.idx]" (mouseover)="cancelHideTimer()" (mouseout)="startHideTimer(post.idx)"  style=" padding: 10px;">
                        <a href="javascript:void(0)" (click)="pageobj2.page=0;subnow='2';get_trade_record(data[post.idx]);" data-toggle="modal" data-target=".bd-example-modal-xl">
                            <i style="margin: 0 10px 0 0;" class="fas fa-receipt"></i>
                        </a>
                        <a href="javascript:void(0)" (click)="pageobj2.page=0;subnow='4';init_chart(data[post.idx]);" data-toggle="modal" data-target=".bd-example-modal-xl">
                            <i style="margin: 0 10px 0 0;" class="fas fa-chart-line"></i>
                        </a>
                    </div>
                </span>
                <span *ngIf="data[post.idx] &&  post.key=='last_singin_date'" id="ggwp1" (click)="subnow='1';edit_data=data[post.idx].login" data-toggle="modal" data-target=".bd-example-modal-xl">
                    <a href="javascript:void(0)">{{data[post.idx].last_singin_date}}</a>
                </span>
            </ng-template>
            <ng-template let-post #operation_mb>
                <span *ngIf="data[post.idx] && post.key == 'name'">
                    <a target="_blank" href="{{link}}/user/{{data[post.idx].uid}}">
                        <span class="user_identity_{{data[post.idx].identity}}">
                            {{data[post.idx].name}}
                            <div *ngIf="data[post.idx].v_name && data[post.idx].v_name.length>0">({{data[post.idx].v_name}})</div>
                        </span>
                    </a>
                </span>
                <span *ngIf="data[post.idx] && post.key=='profile_pic'">
                    <img loading="lazy" [src]="data[post.idx].profile_pic" style="width: 90%;">
                </span>
                <span *ngIf="data[post.idx] &&  post.key=='name' && data.length>0" class="user_identity_{{data[post.idx].identity}}">
                    <div *ngIf="data[post.idx].v_name && data[post.idx].v_name.length>0">({{data[post.idx].v_name}})</div>
                </span>
                <span *ngIf="data[post.idx] &&  post.key=='last_singin_date'" (click)="subnow='1';edit_data=data[post.idx].login" data-toggle="modal" data-target=".bd-example-modal-xl">
                    <a href="javascript:void(0)">{{data[post.idx].last_singin_date}}</a>
                </span>
                <span *ngIf="data[post.idx] &&  post.key=='send_chats_num'" (click)="get_chat(data[post.idx]);">
                    <a href="javascript:void(0)">{{data[post.idx].send_chats_num}}</a>
                </span>
                <span *ngIf="data[post.idx] &&  post.key=='receve_chats_num'" (click)="get_chat(data[post.idx]);">
                    <a href="javascript:void(0)">{{data[post.idx].receve_chats_num}}</a>
                </span>
                <span *ngIf="data[post.idx] &&  post.key=='diamond'" (click)="pageobj2.page=0;subnow='2';get_trade_record(data[post.idx]);" data-toggle="modal" data-target=".bd-example-modal-xl">
                    <a href="javascript:void(0)">{{data[post.idx].diamond|number}}鑽</a>
                </span>
            </ng-template>
        </r-table>

        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    </div>
    <div *ngIf="now=='1'" style="margin-left:10px ;">
        <r-table [data]="posts_input" (callback)="init_list()"></r-table>
        <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
        <div *ngIf="data.length==0">無資料</div>
    </div>
    <div *ngIf="now=='2'" style="margin-left:10px ;">
        <div style="display:flex;justify-content: space-between;">
            <div>
                扮演角色：
                <button class="btn btn-info" (click)="cancel_user()">
                    <img loading="lazy" style="height: 60px;" [src]="chat_obj.mepic">
                    {{chat_obj.mename}}
                </button>
            </div>
            <div>
                {{pageobj3.page*pageobj3.count + chat_list_data.length}}/{{pageobj3.total_count}}筆
            </div>
        </div>
        <div style="margin-top: 10px;">
            <input (keyup.enter)="pageobj3.page=0;chat_list()" type="text" [(ngModel)]="search_chat_list" style="width: 160px;display:inline-block" class="form-control" placeholder="請輸入姓名或手機">
            <button class="btn btn-primary"  (click)="pageobj3.page=0;chat_list()">確認</button>
        </div>
        <hr>
        <ul class="list-group" *ngFor="let x of chat_list_data">
            <li class="list-group-item d-flex justify-content-between align-items-center">
                <span data-toggle="modal" data-target=".bd-example-modal-xl" (click)="packet=0;select_user(x)">
                    <img loading="lazy" style="width:50px;margin-right: 10px;cursor:pointer" [src]="x.profile_pic">
                    <span >{{x.name}}
                        <div *ngIf="x.v_name && x.v_name.length>0">({{x.v_name}})</div>
                    </span>
                </span>
                <span  data-toggle="modal" data-target=".bd-example-modal-xl"  (click)="packet=0;select_user(x)" style="color:#369;background-color:#eee;cursor: pointer;" class="badge badge-danger badge-pill">{{x.create_dt}}</span>
            </li>
        </ul>
        <app-pagnation (callback)="callback_chat($event)" [data]="pageobjstr3"></app-pagnation> 
    </div>

    <div  *ngIf="edit_data && now=='0' ||now =='2'" class="modal fade bd-example-modal-xl" tabindex="-1" role="dialog"  data-keyboard="false" data-backdrop="static"  aria-labelledby="myExtraLargeModalLabel" aria-hidden="true" >
        <div class="modal-dialog modal-xl">
            <div class="modal-content" *ngIf="subnow=='3'">
                <div class="modal-header">
                    <h5 class="modal-title">聊天明細</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body"> 
                    <div class="caption chat_box" (scroll)="onScroll()" id="chat_box" *ngIf="detail_data.length>0" >		
                        <div *ngFor="let item of detail_data; let i = index"  >
                            <div >
                                <div *ngIf="item.user_uid==chat_obj.me" style="float:right;max-width: 75%;">
                                    <div class="chat_icon">
                                        <span *ngIf="item.type*1==1 && item.content.length>0 && item.user_uid!='system'"  class="triangle-isosceles top c_content">
                                            <span class="chat_right">{{item.content}}</span>
                                        </span>  
                                        <span *ngIf="item.type*1==2 && item.media.file" class="chat_right">      
                                            <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                        </span>       
                                        <span *ngIf="item.type*1==3  && item.media.file" class="chat_right">      
                                            <img loading="lazy"  style="width:100px" [src]="item.media.file[0].file_url"> 
                                        </span>       
                                        <span *ngIf="item.type*1==4  && item.media.file"  class="chat_right">      
                                            <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                        </span>      
                                    
                                        <span *ngIf="item.type*1==5"  class="triangle-isosceles top c_content">      
                                            <span class="chat_right">系統:雙用戶進行遊戲互動</span>
                                        </span>      
                                        <span *ngIf="item.type*1==7"  class="triangle-isosceles top c_content">      
                                            <span class="chat_right">系統:對動態回復了:{{item.content}}</span>
                                        </span>     
                                        <span *ngIf="item.type*1==8||item.type*1==10"  class="triangle-isosceles top c_content">      
                                            <span class="chat_right">系統:招呼語</span>
                                        </span>     
                                        <span *ngIf="item.type*1==9"  class="triangle-isosceles top c_content">      
                                            <span class="chat_right">使用群發:{{item.content}}</span>
                                        </span>     
                                        <span *ngIf="item.type*1==11"  class="triangle-isosceles top c_content">      
                                            <span class="chat_right">系統:贈送了禮物</span>
                                        </span>  
                                        <span *ngIf="item.type*1==14"  class="triangle-isosceles top c_content">      
                                            <span class="chat_right">系統:贈送了活動禮物</span>
                                        </span>
                                        <span *ngIf="item.type*1==16"  class="triangle-isosceles top c_content">      
                                          <span class="chat_left">系統:解鎖動態</span>
                                        </span>    
                                        <span *ngIf="item.type*1==15"  class="triangle-isosceles top c_content">      
                                          <span class="chat_left">系統:報名約會</span>
                                        </span>    
                                        <span>{{item.time}}</span>
                                        <img loading="lazy" [src]="item.tpic" class="user_icon"  style="height:55px;display: none;" /> 
                                        <div style="clear:both;"></div>
                                    </div>
                                </div>

                                <div *ngIf="item.user_uid==chat_obj.to" class="speech_item" style="float:left;max-width: 75%;">
                                    <div class="chat_icon">
                                        <img loading="lazy" [src]="item.fpic" class="user_icon"  style="height:55px" /> 
                                        <span>{{item.time}} </span>
                                        <span *ngIf="item.type*1==1 && item.content.length>0 && item.user_uid!='system'" 
                                          class="triangle-isosceles top c_content">
                                            <span class="chat_left">{{item.content}}</span>
                                        </span> 
                                        <span *ngIf="item.type*1==2 && item.media.file" class="chat_left">      
                                            <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                        </span>       
                                        <span *ngIf="item.type*1==3 && item.media.file" class="chat_left">      
                                            <img loading="lazy"  style="width:100px" [src]="item.media.file[0].file_url"> 
                                        </span>       
                                        <span *ngIf="item.type*1==4 && item.media.file" class="chat_left">      
                                            <video  style="width:200px;" [src]="item.media.file[0].file_url" controls="controls" ></video>
                                        </span>      
                                        <span *ngIf="item.type*1==5"  class="triangle-isosceles top c_content">      
                                            <span class="chat_left">系統:雙用戶進行遊戲互動</span>
                                        </span>      
                                        <span *ngIf="item.type*1==7"  class="triangle-isosceles top c_content">      
                                            <span class="chat_left">系統:對動態回復了:{{item.content}}</span>
                                        </span>     
                                        <span *ngIf="item.type*1==8||item.type*1==10"  class="triangle-isosceles top c_content">      
                                            <span class="chat_left">系統:招呼語</span>
                                        </span>     
                                        <span *ngIf="item.type*1==9" class="triangle-isosceles top c_content">      
                                            <span class="chat_left">系統:使用群發:{{item.content}}</span>
                                        </span>     
                                        <span *ngIf="item.type*1==11"  class="triangle-isosceles top c_content">      
                                            <span class="chat_left">系統:贈送了禮物</span>
                                        </span>  
                                        <span *ngIf="item.type*1==14"  class="triangle-isosceles top c_content">      
                                            <span class="chat_left">系統:贈送了活動禮物</span>
                                        </span>  
                                        <span *ngIf="item.type*1==15"  class="triangle-isosceles top c_content">      
                                          <span class="chat_left">系統:報名約會</span>
                                        </span>  
                                        <span *ngIf="item.type*1==16"  class="triangle-isosceles top c_content">      
                                            <span class="chat_left">系統:解鎖動態</span>
                                        </span>  
                                        <div style="clear:both;"></div>
                                    </div>
                                </div>
                                <div style="clear:both;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-content" *ngIf="subnow=='1'">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">近期登入明細</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
    
                <!-- Modal body -->
                <div class="modal-body"> 
                    <ul  *ngIf="edit_data.length!=0">
                        <li *ngFor="let item of edit_data; let key = index" style="list-style: none;">
                            {{item.date}}日 登入次數:{{item.times}}次
                        </li>
                    </ul> 
                </div>
    
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button"   class="btn btn-primary" data-dismiss="modal">確認</button>
                </div>
            </div>
            <div class="modal-content" *ngIf="subnow=='2'">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">90天內交易明細</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

      
                <!-- Modal body -->
                <div class="modal-body" style="height: 70vh;overflow:auto">            
                    <table class="table table-responsive-sm" >
                        <thead>
                            <tr class="table-secondary" style="font-size:18px;">
                                <th style="width:5%">鑽石總收入</th>
                                <th style="width:5%">鑽石總支出</th>
                                <th style="width:5%">鑽石結餘</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-light" style="font-size:18px;">
                                <td>{{trade_num_info.earn|number}}</td>
                                <td>{{trade_num_info.pay|number}}</td>
                                <td>{{trade_num_info.earn-trade_num_info.pay|number}}</td>
                            </tr>
                        </tbody>
                    </table>  
                    <table class="modal-body">
                        <thead>
                            <tr style="border: solid #eee 2px; border-radius: 5px; margin-bottom: 5px; padding: 10px;">
                                <th style="width:5%">對象</th>
                                <th style="width:5%">類型</th>
                                <th style="width:5%">額度</th>
                                <th style="width:5%">小結</th>
                                <th style="width:5%">日期</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of edit_data; let key = index"  style="border: solid #eee 2px; border-radius: 5px; margin-bottom: 5px; padding: 10px;">
                                <td>
                                    <span *ngIf="item.each_name=='系統'">{{item.each_name}}</span>
                                    <span *ngIf="item.each_name!='系統'">
                                        <a target="_blank" href="{{link}}/useractive/{{item.each_name}}"><span class="user_identity_{{item.identity}}">{{item.each_name}}</span></a>
                                    </span>
                                </td>
                                <td>{{item.rdes}}</td>
                                <td>{{item.added_value|number}}</td>
                                <td>{{item.new_value|number}}</td>
                                <td>{{item.create_dt}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <app-pagnation (callback)="callback2($event)" [data]="pageobjstr2"></app-pagnation> 
                    <!-- Modal footer -->
                <div class="modal-footer" >
                    <button type="button"   class="btn btn-primary" data-dismiss="modal">確認</button>
                </div>
            </div>
            <div class="modal-content" *ngIf="subnow=='4'">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h5 class="modal-title">鑽石數分析</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
    
                <!-- Modal body -->
                <div class="modal-body"> 
                    <ul>
                        <div  class="picchart">
                            <highcharts-chart *ngIf="gender=='2'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions" style="display: block;width: 70%;margin:10px"></highcharts-chart>
                            <highcharts-chart *ngIf="gender=='1'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions2" style="display: block;width: 70%;margin:10px"></highcharts-chart>
                        </div>

                        <div  class="picchart">
                            <highcharts-chart  *ngIf="gender=='2'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions3" style="display: block;width: 70%;margin:10px"></highcharts-chart>
                            <highcharts-chart  *ngIf="gender=='1'" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="areaOptions4" style="display: block;width: 70%;margin:10px"></highcharts-chart>
                        </div>

                    </ul> 
                </div>
    
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button"   class="btn btn-primary" data-dismiss="modal">確認</button>
                </div>
            </div>
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>